import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Same 7-colour palette as peopleiknow.ai; each tall "i" picks its own colour on every page load.
const I_COLORS = ["#ec4899", "#f59e0b", "#10b981", "#8b5cf6", "#06b6d4", "#1d4ed8", "#ef4444"];
const H = 129;
const MASK = "url(/brand/wordmark-i-mask.png)";
const SIZES = {
  md: { word: "h-6 sm:h-9", icon: "h-5 sm:h-[30px]", gap: "gap-1.5 sm:gap-2" },
  sm: { word: "h-6", icon: "h-5", gap: "gap-1.5" },
};
const pick = () => I_COLORS[Math.floor(Math.random() * I_COLORS.length)];

const Part = ({ src, width }) => (
  <img src={src} alt="" aria-hidden="true" className="h-full w-auto shrink-0" style={{ aspectRatio: width / H }} />
);

const TallI = ({ color, testid }) => (
  <span
    aria-hidden="true"
    data-testid={testid}
    data-color={color}
    className="h-full shrink-0"
    style={{
      aspectRatio: 34 / H,
      backgroundColor: color,
      WebkitMaskImage: MASK,
      maskImage: MASK,
      WebkitMaskSize: "contain",
      maskSize: "contain",
      WebkitMaskRepeat: "no-repeat",
      maskRepeat: "no-repeat",
      WebkitMaskPosition: "center",
      maskPosition: "center",
    }}
  />
);

export const BrandLogo = ({ to = "/", size = "md" }) => {
  const [colors, setColors] = useState(["#1d4ed8", "#1d4ed8"]);
  useEffect(() => setColors([pick(), pick()]), []);
  const s = SIZES[size];
  const Wrap = to ? Link : "span";
  return (
    <Wrap {...(to ? { to } : {})} aria-label="Invite PeopleiKnow" data-testid="brand-logo" className={`inline-flex shrink-0 items-end ${s.gap}`}>
      <span role="img" aria-label="invite" data-testid="brand-logo-invite" className={`inline-flex items-center ${s.word}`}>
        <Part src="/brand/wordmark-inv.png" width={138} />
        <TallI color={colors[0]} testid="brand-logo-invite-i" />
        <Part src="/brand/wordmark-te.png" width={94} />
      </span>
      <img src="/brand/app-logo.png" alt="" aria-hidden="true" data-testid="brand-logo-chip" className={`${s.icon} w-auto shrink-0`} />
      <span role="img" aria-label="peopleiknow" data-testid="brand-logo-wordmark" className={`inline-flex items-center ${s.word}`}>
        <Part src="/brand/wordmark-people.png" width={320} />
        <TallI color={colors[1]} testid="brand-logo-i" />
        <Part src="/brand/wordmark-know.png" width={241} />
      </span>
    </Wrap>
  );
};

export const SiteHeader = ({ logoTo = "/", children }) => (
  <header data-testid="site-header" className="sticky top-0 z-50 w-full border-b border-slate-200/60 bg-white/70 shadow-sm backdrop-blur-xl">
    <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-3 px-4 sm:px-8">
      <BrandLogo to={logoTo} />
      {children}
    </div>
  </header>
);

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="mx-auto flex max-w-md flex-col items-center gap-3 px-4 py-10 text-center">
    <a data-testid="site-footer-logo-link" href="https://invite.peopleiknow.ai" target="_blank" rel="noopener noreferrer" aria-label="Invite PeopleiKnow" className="inline-flex rounded-md opacity-90 transition-[opacity,transform] duration-200 hover:-translate-y-px hover:opacity-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-700">
      <BrandLogo size="sm" to={null} />
    </a>
    <p data-testid="site-footer-text" className="text-[11px] leading-relaxed text-slate-400">
      <a data-testid="site-footer-link" href="https://invite.peopleiknow.ai" target="_blank" rel="noopener noreferrer" className="font-semibold text-slate-500 underline-offset-2 hover:text-blue-700 hover:underline">
        Invite PeopleiKnow
      </a>{" "}
      is a{" "}
      <a data-testid="site-footer-pik-link" href="https://www.peopleiknow.ai" target="_blank" rel="noopener noreferrer" className="text-slate-500 underline-offset-2 transition-colors hover:text-blue-700 hover:underline">
        PeopleiKnow™
      </a>{" "}
      product. Try it for your events! Invite PeopleiKnow will be integrated into PeopleiKnow in the future.
    </p>
  </footer>
);
